import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import ValueStrip from "@/components/sections/ValueStrip";
import DemoWebsites from "@/components/sections/DemoWebsites";
import HowItWorks from "@/components/sections/HowItWorks";
import IncludedFeatures from "@/components/sections/IncludedFeatures";
import Pricing from "@/components/sections/Pricing";
import FAQ from "@/components/sections/FAQ";
import LeadForm from "@/components/sections/LeadForm";
import { captureAttribution } from "@/lib/attribution";

const JSON_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Get Online Crew",
  url: "https://getonlinecrew.com",
  slogan: "Your business website, handled.",
  description:
    "Get Online Crew builds professional, mobile-friendly websites for small businesses and handles setup, hosting, maintenance, and support.",
};

export default function Home() {
  useEffect(() => {
    captureAttribution();
    document.title =
      "Get Online Crew | Professional Websites for Small Businesses";

    const setMeta = (name, content, attr = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const description =
      "Get a professional, mobile-friendly website built for your small business. Get Online Crew handles design, setup, hosting, maintenance, and support.";
    const title =
      "Get Online Crew | Professional Websites for Small Businesses";

    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", "Get Online Crew", "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${window.location.origin}/`);

    // JSON-LD structured data
    const scriptId = "goc-jsonld";
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = scriptId;
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(JSON_LD);

    // Smooth-scroll into a hash on initial navigation from another route.
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) {
        setTimeout(
          () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
          50,
        );
      }
    }
  }, []);

  return (
    <>
      <Navbar />
      <main data-testid="home-main">
        <Hero />
        <ValueStrip />
        <DemoWebsites />
        <HowItWorks />
        <IncludedFeatures />
        <Pricing />
        <FAQ />
        <LeadForm />
      </main>
      <Footer />
    </>
  );
}
